import type {
  RuntimeConfig,
  AssociationPhoneSelection,
} from '@provider-directory/types/runtime-config.contracts';

/**
 * "This directory does not select a phone number by association." Consumers
 * already handle it: `resolveAssociationPhone` returns undefined for a disabled
 * selection and the caller falls back to the directory's own scheduling number.
 */
const NO_ASSOCIATION_PHONE_SELECTION: AssociationPhoneSelection = {
  enabled: false,
  precedence: [],
  byHospitalAssociation: {},
};

/**
 * Association-based phone selection for a directory, from its runtime config. An
 * absent `associationPhoneSelection` means the directory opts out; the runtime
 * config itself is always present — there is no second source.
 */
export const resolveAssociationPhoneSelection = ({
  runtimeConfig,
}: {
  runtimeConfig: RuntimeConfig;
}): AssociationPhoneSelection =>
  runtimeConfig.associationPhoneSelection ?? NO_ASSOCIATION_PHONE_SELECTION;
